
const edccResultCallback = (error, result) => {
  console.log('EDCC result: ', error, result);
};


const getCallbacksParams = () => {
  return {
    resultCallback: edccResultCallback,
  }
};

const getResultCallbacksTemplate = () => {
  return `
function edccResultCallback(error, results) {
  console.log('EDCC result:', error, results);
}
    `;
};

const getCallbacksTemplate = () => {
  return `
optionalParameters.edcc.resultCallback = edccResultCallback;
  `;
};

export const EdccHelper = {
  getCallbacksParams,
  getResultCallbacksTemplate,
  getCallbacksTemplate
};



// WEBPACK FOOTER //
// ./src/helpers/EdccHelper.js